export const copyToClipboard = (value) => {
  try {
    if (navigator?.clipboard) {
      navigator.clipboard.writeText(value);
    }
  } catch (err) {
    console.log(err);
  }
};
